import { inject, Injectable } from '@angular/core';
import { SessionStorageService } from './session-storage.service';

@Injectable({
  providedIn: 'root'
})
export class NavigationStore {
  private sessionStorage = inject(SessionStorageService);

  private readonly lastUrlKey: string = 'lastURL';
  private readonly backUrlKey: string = 'backURL';

  public setLastUrl(url: string): void {
    if (!url) return;

    this.sessionStorage.setItem(this.lastUrlKey, url);
  }

  public getLastUrl(): string | null {
    return this.sessionStorage.getItem(this.lastUrlKey);
  }

  public setBackUrl(url: string): void {
    if (!url) return;

    this.sessionStorage.setItem(this.backUrlKey, url);
  }

  public getBackUrl(): string | null {
    return this.sessionStorage.getItem(this.backUrlKey);
  }

  public clearBackUrl(): void {
    this.sessionStorage.removeItem(this.backUrlKey);
  }

  public resolveReturnUrl(defaultUrl: string): string {
    return this.getBackUrl() || this.getLastUrl() || defaultUrl;
  }
}
